<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :get-action="queryApi"
      :selection="selection"
      :col-span="colSpan"
      :serial="serial"
      :before-reset-search="beforeResetSearch"
      :tooltip-config="{ showAll: false, enterable: false }"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <!-- 客户名称 -->
        <el-col :span="colSpan" v-if="!$store.getters.cusId">
          <el-form-item :label="$t('billingPage.CustomerName')" prop="cusId">
            <BjSelectLov v-model="queryParams.cusId" :option-list="customerList" :placeholder="$t('customerNameText')" />
          </el-form-item>
        </el-col>
        <!-- 状态 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('table.statusText')" prop="statusList">
            <BjSelectLov v-model="queryParams.statusList" :clearable="false" multiple :option-list="statusList" @change="chooseSome"/>
          </el-form-item>
        </el-col>
        <!-- 开始时间 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagementAdd.onTime')" prop="queryParamsTime_start">
            <BjDateRangePicker v-model="queryParamsTime_start" :placeholder="$t('AccountManagementAdd.onTime')" />
          </el-form-item>
        </el-col>
        <!-- 结束时间 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagementAdd.offTime')" prop="queryParamsTime_end">
            <BjDateRangePicker v-model="queryParamsTime_end" :placeholder="$t('AccountManagementAdd.offTime')" />
          </el-form-item>
        </el-col>
        <!-- 操作人 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('workOrderList.Operator')" prop="operater">
            <BjInput
              v-model="queryParams.operater"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('workOrderList.Operator')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
      </template>

      <!-- 展示列表 -->
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'"
          :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
          :prop="col.prop"
          :label="col.label"
          :width="col.width || 'auto'"
          :fixed="col.fixed || false"
          align="center"
          class-name="item"
          :show-overflow-tooltip="col.prop !== 'bjTableAction'">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop == 'cusId'">{{ customerList.bjGet(scope.row.cusId) }}</template>
              <template v-else-if="col.prop === 'status'">
                <span>{{ scope.row[col.prop] == '1' ? $t('completedText') : scope.row[col.prop] == '2' ? $t('canceledText') : '' }}</span>
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { purchaseApi } from '@/api';
// import DataForm from './components/DataForm.vue';
export default {
  name: 'BusinessPurchaseTemporaryNot',
  components: {
    // DataForm
  },
  mixins: [pageMiXin],
  data() {
    return {
      selection: false,
      colSpan: 4,
      // 查询参数
      queryApi: purchaseApi.getPurchaseTemporaryList,
      queryParamsTime_start: [],
      queryParamsTime_end: [],
      queryParams: {
        cusId: this.$store.getters.cusId || null,
        statusList: ['1','2'],
        startTimeBegin: null,
        startTimeEnd: null,
        endTimeBegin: null,
        endTimeEnd: null,
        operater: null,
      },
      // 状态下拉列表
      statusList:[ 
        { label: this.$t('completedText'), value: '1' },
        { label: this.$t('canceledText'), value: '2' }
      ],

      labelList1: [
        { label: this.$t('billingPage.CustomerName'), prop: 'cusId', isCheck: true, disabled: false },
        { label: this.$t('billingPage.PalletQty'), prop: 'palletQty', isCheck: true, disabled: false },
        { label: this.$t('AccountManagementAdd.status'), prop: 'status', isCheck: true, disabled: false },
        { label: this.$t('billingPage.startDate'), prop: 'startTime', isCheck: true, disabled: false },
        { label: this.$t('billingPage.endDate'), prop: 'endTime', isCheck: true, disabled: false },
        { label: this.$t('closingTime'), prop: 'lastUpdateDate', isCheck: true, disabled: false },
        { label: this.$t('BjDialogListConfig.Operator'), prop: 'operater', isCheck: true, disabled: false },
      ]
    };
  },
  computed: {
    labelList() {
      return this.$store.getters.cusId ? this.labelList1.filter(item => item.prop != 'cusId') : this.labelList1;
    },
  },
  watch: {
    // 开始日期
    queryParamsTime_start(v) {
        this.queryParams.startTimeBegin = (v || [])[0];
        this.queryParams.startTimeEnd = (v || [])[1];
    },
    // 结束日期
    queryParamsTime_end(v) {
        this.queryParams.endTimeBegin = (v || [])[0];
        this.queryParams.endTimeEnd = (v || [])[1];
    },
  },
  methods: {
    chooseSome(event){
      if(event.length == 0){
        this.queryParams.statusList = ['1','2']
      }
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime_start = null;
      this.queryParamsTime_end = null;
      return new Promise(resolve => {
        resolve();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
